import Vue from 'vue'
import Axios from 'axios'
import * as API from '@/endpoints'

export default {
  namespaced: true,
  state: {
    count: 0,
    userFields: []
  },
  getters: {
    interests: (state, getters) => {
      let field = !getters.profile || getters.profile.fields.find(field => {
        return field.slug === 'interest'
      })

      return field && field.options ? field.options : []
    },

    supports: (state, getters) => {
      let field = !getters.profile || getters.profile.fields.find(field => {
        return field.slug === 'type_supported'
      })

      return field && field.options ? field.options : []
    },

    profile: (state, getters) => {
      return state.userFields.find(item => {
        return item.group_slug === 'profile'
      })
    }
  },
  mutations: {
    setUserFields(state, v) {
      Vue.set(state, 'userFields', v)
    }
  },
  actions: {
    validateCode({ }, code) {
      return Axios.post(API.endpoints.base + "/user/validate/code", {
        code : code
      }).then(res => {
        return Promise.resolve(res.data)
      }).catch(err => {
        return Promise.reject(err);
      })
    },
    resendMobileCode({ }, mobile) {
      return Axios.post(API.endpoints.base + "mobile/resend/code", {
        mobile : mobile
      }).then(res => {
        return Promise.resolve(res.data)
      }).catch(err => {
        return Promise.reject(err);
      })
    },
    resendEmailCode({ }, email){
      return Axios.post(API.endpoints.base + "user/email/activate/resend", {
        email : email
      }).then(res => {
        return Promise.resolve(res.data)
      }).catch(err => {
        return Promise.reject(err);
      })
    }
  }
}
